export const AlienLogo = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <radialGradient id="alien-head" cx="50%" cy="45%" r="55%">
        <stop offset="0%" stopColor="#5AFF3A" />
        <stop offset="60%" stopColor="#39FF14" />
        <stop offset="100%" stopColor="#0F5B08" />
      </radialGradient>
    </defs>
    {/* Head */}
    <path
      d="M32 4 C46 4 56 16 56 30 C56 44 46 60 32 60 C18 60 8 44 8 30 C8 16 18 4 32 4 Z"
      fill="url(#alien-head)"
      stroke="#0A0A0A"
      strokeWidth="1.5"
    />
    {/* Eyes */}
    <ellipse cx="22" cy="34" rx="6" ry="9" fill="#0A0A0A" className="alien-eye" />
    <ellipse cx="42" cy="34" rx="6" ry="9" fill="#0A0A0A" className="alien-eye" />
    {/* Eye highlights */}
    <ellipse cx="24" cy="30" rx="1.5" ry="2" fill="#F0F0F0" />
    <ellipse cx="44" cy="30" rx="1.5" ry="2" fill="#F0F0F0" />
    {/* Mouth */}
    <path d="M26 48 Q32 52 38 48" stroke="#0A0A0A" strokeWidth="1.5" fill="none" strokeLinecap="round" />
  </svg>
);
